import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { getReleaseById, updateReleaseById } from '../controllers/releaseController';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format, parseISO } from 'date-fns';
import { toast } from 'react-toastify';

const ReleaseEditView = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [release, setRelease] = useState({
        display_name: '',
        issued_date: '',
        type: '',
        cover_image: '',
        is_free: false,
        introduction: '',
        cover_file: null,
    });

    var magazine_id = null;
    var magazineL = localStorage.getItem('magazine');

    const [preview, setPreview] = useState(null);


    useEffect(() => {
        if (magazineL) {
            magazine_id = JSON.parse(magazineL).magazine_id;
        }
        const params = {
            magazineId: magazine_id,
            releaseId: id
        };
        getReleaseById(params, setRelease);
    }, [id]);


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setRelease(prev => ({
                ...prev,
                cover_file: file,
            }));
            setPreview(URL.createObjectURL(file)); // Set preview image
        }
    };
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;
        setRelease(prev => ({ ...prev, [name]: val }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const params = {
            magazineId: magazine_id,
            releaseId: id
        };
        try {
            await updateReleaseById(params, release, setRelease);  // Ensure your controller handles FormData
            toast.success("Release updated successfully!");
            setTimeout(() => {
                navigate(`/releases/${id}`);
            }, 1000);
        } catch (error) {
            toast.error("Failed to update release.");
        }

    };


    if (!release) return <p>Loading...</p>;

    return (
        <div className="container mt-4">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title fw-semibold mb-4">Edit Release</h5>
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-11">
                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-3">
                                            <label>Name</label>
                                            <input
                                                name="display_name"
                                                value={release.display_name}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                        </div>


                                        <div className="mb-3">
                                            <label>Introduction</label>
                                            <textarea
                                                name="introduction"
                                                value={release.introduction}
                                                onChange={handleChange}
                                                className="form-control"
                                                rows="4"
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label>GA Code (Google Analytics)</label>
                                            <input
                                                name="ga_code"
                                                value={release.ga_code}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label>Is Free</label>
                                            <select
                                                name="is_free"
                                                value={release.is_free ? '1' : '0'}
                                                onChange={(e) =>
                                                    setRelease(prev => ({ ...prev, is_free: e.target.value === '1' }))
                                                }
                                                className="form-select"
                                            >
                                                <option value="1">Yes</option>
                                                <option value="0">No</option>
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label>Issued Date</label>
                                            <br />
                                            <DatePicker
                                                name="issued_date"
                                                selected={release.issued_date ? parseISO(release.issued_date) : null}
                                                onChange={(date) => {
                                                    setRelease(prev => ({
                                                        ...prev,
                                                        issued_date: format(date, 'yyyy-MM-dd'),
                                                    }));
                                                }}
                                                dateFormat="yyyy-MM-dd"
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className='form-label'>Publish Date</label>
                                            <br />
                                            <DatePicker
                                                name="publish_date"
                                                selected={release.publish_date ? parseISO(release.publish_date) : null}
                                                onChange={(date) => {
                                                    setRelease(prev => ({
                                                        ...prev,
                                                        publish_date: format(date, 'yyyy-MM-dd'),
                                                    }));
                                                }}
                                                dateFormat="yyyy-MM-dd"
                                                className="form-control"
                                            />
                                        </div>
                                        <button type="submit" className="btn btn-success">Save</button>
                                        <button type="button" className="btn btn-secondary ms-2" onClick={() => navigate(-1)}>Cancel</button>
                                    </form>

                                </div>
                                <div className="col-lg-1">
                                    <button className="btn btn-sm btn-secondary me-2" onClick={() => navigate(-1)}>
                                        Back
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReleaseEditView;
